
import { computed, defineComponent } from "vue";
import BaseHeader from "./components/BaseHeader.vue";
import Loading from "./components/Loading.vue";
import { useStore } from "vuex";

export default defineComponent({
  name: "App",
  components: {
    BaseHeader,
    Loading,
  },
  setup() {
    const store = useStore();
    const IsLoggedIn = computed(
      () => store.getters["loadingState/getIsLoading"]
    );

    return {
      IsLoggedIn,
    };
  },
});
